module.exports = __webpack_public_path__ + "img/icon-notice-on.8d587b2e.svg";